module.exports = __webpack_public_path__ + "img/fifth_cloud_top.5153705f.png";